import { useUiStore } from '../../stores/uiStore.js';
import type { SidebarTab } from '../../types/index.js';

const TABS: { id: SidebarTab; label: string; emoji: string }[] = [
  { id: 'locations', label: 'Locations', emoji: '📌' },
  { id: 'projects', label: 'Scenes', emoji: '🎬' },
  { id: 'days', label: 'Days', emoji: '📅' },
];

export function TabNav() {
  const { activeTab, setActiveTab } = useUiStore();

  return (
    <div className="flex border-b border-gray-200 px-2">
      {TABS.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex-1 flex flex-col items-center py-2.5 text-xs font-medium transition-colors border-b-2 ${
            activeTab === tab.id
              ? 'border-brand-500 text-brand-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          <span className="text-base">{tab.emoji}</span>
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
}
